import script from "./widget-chart.vue?vue&type=script&lang=ts&setup=true"
export * from "./widget-chart.vue?vue&type=script&lang=ts&setup=true"

import "./widget-chart.vue?vue&type=style&index=0&id=5c6a08b0&lang=css"

const __exports__ = script;

export default __exports__